// extracted by mini-css-extract-plugin
module.exports = {"container":"Spinner_container__lrj1S","spinner":"Spinner_spinner__2_Kv4"};